<template>
  <v-container fluid class="pa-0">
      <v-app-bar app clipped-right fixed :class="isMeetingPage ? 'pb-3' : '' " class="pt-1 appBarAutoHeight" flat>            
        <slot name="page-fixed-header" />      
      
      </v-app-bar>

        <v-card flat color="Neutral">        
          <v-col cols="12" sm="12" md="12" :class="$route.path == '/agenda' ? 'pa-0' : 'pa-0 mt-2'">
            <slot name="page-content" />
          </v-col>
        </v-card>

  </v-container>
</template>

<script>
export default {
  name: "PageContainer",
  computed: {
    isMeetingPage() {
      return this.$route.path.startsWith('/meeting/');
    }
  }
};
</script>
<style scoped>
.appBarAutoHeight{
  height: fit-content !important;
  border-bottom: 1px solid var(--v-Neutral-darken1) !important; 
}

.appBarAutoHeight /deep/ .v-toolbar__content {
  height: fit-content !important;
  align-items: flex-start;
}

</style>
